import { PublicEducator } from '@cademy-package/sdk-component-types';
import React, { FunctionComponent } from 'react';
import { FacebookIcon, LinkedinIcon, TwitterXIcon, EnvelopeSolidIcon } from '../Icons';
import classNames from 'classnames';
import styles from './styles.module.scss';

type ShareLinksProps = {
    shareText: string;
    shareLink: string;
    educatorFeatureFlags?: PublicEducator['feature_flags'];
};

export const ShareLinks: FunctionComponent<ShareLinksProps> = ({
    shareText,
    shareLink,
    educatorFeatureFlags,
}) => {
    if (educatorFeatureFlags?.hide_social_prompts) return null;

    return (
        <div className={styles.container}>
            <h3>Share with your network</h3>
            <ul className={styles.socialList}>
                <li aria-label="Facebook list item">
                    <a
                        className={classNames(styles.iconLink, styles.facebook)}
                        aria-label="Facebook share link"
                        href={`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FacebookIcon />
                    </a>
                </li>
                <li aria-label="Twitter / X list item">
                    <a
                        className={classNames(styles.iconLink, styles.twitter)}
                        aria-label="Twitter / X share link"
                        href={`https://twitter.com/intent/tweet?url=${shareLink}&text=${shareText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <TwitterXIcon />
                    </a>
                </li>
                <li aria-label="LinkedIn list item">
                    <a
                        className={classNames(styles.iconLink, styles.linkedIn)}
                        aria-label="LinkedIn share link"
                        href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}&title=${shareText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <LinkedinIcon />
                    </a>
                </li>
                <li aria-label="Email list item">
                    <a
                        className={classNames(styles.iconLink, styles.email)}
                        aria-label="Email share link"
                        href={`mailto:?body=${shareLink}&subject=${shareText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <EnvelopeSolidIcon />
                    </a>
                </li>
            </ul>
        </div>
    );
};
